import {detectHasAnswer} from '../MaturaExamRunner/MaturaExamSnapshotUtils';

export function hasIncompleteQuizAnswers(tasks, answers, containers) {
  return tasks.some((task, index) => {
    if (!detectHasAnswer(answers[index])) return true;
    // Inspect only the answer area, excluding the whiteboard and its controls.
    const fields = containers[index]?.querySelectorAll('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([data-optional]), textarea:not([data-optional])') || [];
    return Array.from(fields).some(field => !field.disabled && !field.value.trim());
  });
}
